<div class="digit-dropdown-container" [matMenuTriggerFor]="disabled ? null : menuDigits" #menuTrigger="matMenuTrigger" (menuOpened)="onMenuOpened()" (menuClosed)="onMenuClosed()">
  <app-basic-textbox
    [model]="model"
    [placeholder]="placeholder"
    [label]="title"
    [width]="textboxWidth"
    [disabled]="disabled"
    [hasError]="hasError"
    [errorText]="errorText"
    [size]="'x-small'"
    [readonly]="'true'"
    (modelChange)="onModelChange($event)">
  </app-basic-textbox>
</div>

<mat-menu #menuDigits="matMenu" class="digit-menu" [overlapTrigger]="false" panelClass="digit-menu-panel">
  <div class="digit-menu-list">
    <button
      *ngFor="let digit of digits; let i = index"
      mat-menu-item
      (click)="selectDigit(digit, $event)"
      class="digit-menu-item"
      [class.item-10]="digit == model"
      tabindex="-1"
      (mousedown)="$event.preventDefault()">
      {{digit}}
    </button>
  </div>
</mat-menu>

